import { render, staticRenderFns } from "./gymRatingGraphicAvgStudentJump.vue?vue&type=template&id=04c7aff9&"
import script from "./gymRatingGraphicAvgStudentJump.js?vue&type=script&lang=js&"
export * from "./gymRatingGraphicAvgStudentJump.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports